export default function getCommaSeparatedList(items, prop, array, target, rank) {
  const list = [];
  if (items && items[prop] && Object.prototype.hasOwnProperty.call(items[prop], array)) {
    if (rank) {
      items[prop][array].forEach(element => {
        if (element.rank === rank) {
          list.push(element[target].desc);
        }
      });
    } else {
      items[prop][array].forEach(element => {
        list.push(element[target].desc);
      });
    }
  }
  return list.join();
}